<!-- Default toast for general messages (no key) -->
<p-toast></p-toast>

<app-loading-indicator *ngIf="(loading$ | async)"></app-loading-indicator>

<!-- Render the notification component if you still want inputs-driven publishing -->
<app-expiry-notification *ngIf="toastData" [message]="toastData.message" [severity]="toastData.severity">
</app-expiry-notification>

<router-outlet></router-outlet>